import React, {Component} from 'react';
import {Tree, Icon} from 'antd';

// 样式引入
import './index.css';

import logo from './assets/images/logo.png';
import logoColl from './assets/images/logosm.png';

const {TreeNode} = Tree;

function arrFormat(directoryN) {
    //3为2级  4为3级  5为4级  6为5级
    var arr0 = [];

    if (directoryN.length - '' === 2) {
        let one = directoryN[0] + '-' + directoryN[1];
        arr0.push(one)
    } else if (directoryN.length - '' === 3) {
        let one = directoryN[0] + '-' + directoryN[1];
        let two = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2];
        arr0.push(one)
        arr0.push(two)

    } else if (directoryN.length - '' === 4) {
        let one = directoryN[0] + '-' + directoryN[1];
        let two = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2];
        let three = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2] + '-' + directoryN[3];
        arr0.push(one)
        arr0.push(two)
        arr0.push(three)

    } else if (directoryN.length - '' === 5) {
        let one = directoryN[0] + '-' + directoryN[1];
        let two = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2];
        let three = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2] + '-' + directoryN[3];
        let four = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2] + '-' + directoryN[3] + '-' + directoryN[4];
        arr0.push(one)
        arr0.push(two)
        arr0.push(three)
        arr0.push(four)

    } else if (directoryN.length - '' === 6) {
        let one = directoryN[0] + '-' + directoryN[1];
        let two = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2];
        let three = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2] + '-' + directoryN[3];
        let four = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2] + '-' + directoryN[3] + '-' + directoryN[4];
        let five = directoryN[0] + '-' + directoryN[1] + '-' + directoryN[2] + '-' + directoryN[3] + '-' + directoryN[4] + '-' + directoryN[5];
        arr0.push(one)
        arr0.push(two)
        arr0.push(three)
        arr0.push(four)
        arr0.push(five)

    }

    return arr0;
}

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            signArr: [],
        };
    }

    componentWillMount() {
        var url = window.location.href;
        //获取到 &/ 后边的值
        const keys = url.split('&/')[1];

        //确定章节
        if (keys) {
            const directoryNum = keys.split('0-', 2)[1];
            const directoryN = keys.split('-');

            if (directoryNum && directoryNum !== 0) {
                //其余章
                this.setState({signArr: arrFormat(directoryN)})

            } else {
                //第一章
                this.setState({signArr: arrFormat(directoryN)})
            }

        } else {
            //无章
        }

    }

    onExpand = () => {
        console.log('Trigger Expand');
    };

    //点击
    onSelect = (keys) => {
        window.location.href = window.location.origin + window.location.pathname + '#/data' + '/&/' + keys;
    };

    render() {

        const {signArr} = this.state;

        return (
            <div style={{
                width: '100%',
                height: '100vh',
                background: '#eee',
                overflow: 'hidden',
            }}>
                <div className="sider-logo">{this.state.collapsed ? <img
                    src={logoColl} alt="logo"/> : <img src={logo} alt="logo"/>}</div>
                <h2 style={{marginLeft: '10px'}}>目录</h2>

                <div id="domeSider" style={{
                    height: 'calc( 100vh - 120px )',
                    overflowY: 'auto'
                }}>
                    <div ref="divSider" style={{
                        width: '100%',
                        overflow: 'hidden'
                    }}>
                        <Tree
                            showLine={false}
                            showIcon={false}
                            defaultExpandAll={false}
                            defaultExpandedKeys={signArr}
                            onSelect={this.onSelect}
                            style={{
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                            }}
                        >
                            {/*第一章*/}
                            <TreeNode icon={<Icon type="carry-out"/>}
                                      title="第一章 公司概况" key="0-0" id="0-0" className="siderNum">
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="一 企业文化" key="0-0-0" id="0-0-0" className="siderNum"/>
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="二 公司简介" key="0-0-1" id="0-0-1" className="siderNum">
                                    <TreeNode icon={<Icon type="carry-out"/>}
                                              title="1 公司介绍" key="0-0-1-0" id="0-0-1-0" className="siderNum"/>
                                    <TreeNode icon={<Icon type="carry-out"/>}
                                              title="2 愿景图" key="0-0-1-1" id="0-0-1-1" className="siderNum"/>
                                </TreeNode>
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="三 发展历程" key="0-0-2" id="0-0-2" className="siderNum"/>
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="四 机构设置" key="0-0-3" id="0-0-3" className="siderNum">
                                    <TreeNode icon={<Icon type="carry-out"/>}
                                              title="1 机构图" key="0-0-3-0" id="0-0-3-0" className="siderNum"/>
                                    <TreeNode icon={<Icon type="carry-out"/>}
                                              title="2 人事安排" key="0-0-3-1" id="0-0-3-1" className="siderNum"/>
            
                                </TreeNode>
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="五 专有名词定义" key="0-0-4" id="0-0-4" className="siderNum"/>
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="六 工作法" key="0-0-5" id="0-0-5" className="siderNum"/>
                            </TreeNode>
                            {/*第一章*/}
                            {/*第二章*/}
                            <TreeNode icon={<Icon type="carry-out"/>}
                                      title="第二章 集团员工职业发展" key="0-1" id="0-1" className="siderNum">
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="一 技能职级分类图和岗位称谓划分图" key="0-1-0" id="0-1-0" className="siderNum"/>
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="二 技能职级与岗位称谓说明" key="0-1-1" id="0-1-1" className="siderNum"/>
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="三 2021年技能职级划分和调整的必要条件" key="0-1-2" id="0-1-2" className="siderNum"/>
                                <TreeNode icon={<Icon type="carry-out"/>}
                                          title="四 收入构成—积分管理细则" key="0-1-3" id="0-1-3" className="siderNum">
                                    <TreeNode icon={<Icon type="carry-out"/>}
                                              title="1 职级工资" key="0-1-3-0" id="0-1-3-0" className="siderNum"/>
                                    <TreeNode icon={<Icon type="carry-out"/>}
                                              title="2 固定积分收入（能力分）"
                                              key="0-1-3-1" id="0-1-3-1" className="siderNum"/>
                                    <TreeNode icon={<Icon type="carry-out"/>}
                                              title="3 动态积分收入（结果分）"
                                              key="0-1-3-2" id="0-1-3-2" className="siderNum">
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.1 动态积分的设定内容"
                                            key="0-1-3-2-0" id="0-1-3-2-0" className="siderNum"/>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.2 动态积分收入说明"
                                            key="0-1-3-2-1" id="0-1-3-2-1" className="siderNum"/>
                                    </TreeNode>
                                    <TreeNode icon={<Icon type="carry-out"/>}
                                              title="4 员工收入一览表" key="0-1-3-3" id="0-1-3-3" className="siderNum"/>
                                </TreeNode>

                            </TreeNode>
                          
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第三章 人事行政管理制度"
                                key="0-2"
                                id="0-2" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、人事招/入/离/转/调/管理细则"
                                    key="0-2-0"
                                    id="0-2-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、招聘录用管理细则"
                                        key="0-2-0-0"
                                        id="0-2-0-0" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.1 总则"
                                            key="0-2-0-0-0"
                                            id="0-2-0-0-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.2 招聘录用原则"
                                            key="0-2-0-0-1"
                                            id="0-2-0-0-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.3 招聘需求"
                                            key="0-2-0-0-2"
                                            id="0-2-0-0-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.4 招聘渠道"
                                            key="0-2-0-0-3"
                                            id="0-2-0-0-3" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.5 人员甄选"
                                            key="0-2-0-0-4"
                                            id="0-2-0-0-4" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.6 背景调查"
                                            key="0-2-0-0-5"
                                            id="0-2-0-0-5" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.7 人员录用"
                                            key="0-2-0-0-6"
                                            id="0-2-0-0-6" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.8 附则"
                                            key="0-2-0-0-7"
                                            id="0-2-0-0-7" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、员工入职管理细则"
                                        key="0-2-0-1"
                                        id="0-2-0-1" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.1 入职通知"
                                            key="0-2-0-1-0"
                                            id="0-2-0-1-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.2 新员工报到"
                                            key="0-2-0-1-1"
                                            id="0-2-0-1-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.3 正式入职"
                                            key="0-2-0-1-2"
                                            id="0-2-0-1-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.4 社会保险缴纳"
                                            key="0-2-0-1-3"
                                            id="0-2-0-1-3" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.5 入职声明"
                                            key="0-2-0-1-4"
                                            id="0-2-0-1-4" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.6 入职指引培训"
                                            key="0-2-0-1-5"
                                            id="0-2-0-1-5" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、员工离职管理细则"
                                        key="0-2-0-2"
                                        id="0-2-0-2" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.1 目的"
                                            key="0-2-0-2-0"
                                            id="0-2-0-2-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.2 试用范围"
                                            key="0-2-0-2-1"
                                            id="0-2-0-2-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.3 离职种类"
                                            key="0-2-0-2-2"
                                            id="0-2-0-2-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.4 离职管理职责"
                                            key="0-2-0-2-3"
                                            id="0-2-0-2-3" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.5 离职管理的审批权限"
                                            key="0-2-0-2-4"
                                            id="0-2-0-2-4" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.6 解除劳动合同流程"
                                            key="0-2-0-2-5"
                                            id="0-2-0-2-5" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.7 流程各环节作业规范"
                                            key="0-2-0-2-6"
                                            id="0-2-0-2-6" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.8 公司对离职员工的经济补偿"
                                            key="0-2-0-2-7"
                                            id="0-2-0-2-7" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.9 辞职员工对公司的赔偿"
                                            key="0-2-0-2-8"
                                            id="0-2-0-2-8" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.10 档案管理"
                                            key="0-2-0-2-9"
                                            id="0-2-0-2-9" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.11 附则"
                                            key="0-2-0-2-10"
                                            id="0-2-0-2-10" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、员工转正管理细则"
                                        key="0-2-0-3"
                                        id="0-2-0-3" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.1 总则"
                                            key="0-2-0-3-0"
                                            id="0-2-0-3-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.2 转正考核管理规定"
                                            key="0-2-0-3-1"
                                            id="0-2-0-3-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.3 转正考核流程"
                                            key="0-2-0-3-2"
                                            id="0-2-0-3-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.4 操作管理规定"
                                            key="0-2-0-3-3"
                                            id="0-2-0-3-3" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、员工调动管理细则"
                                        key="0-2-0-4"
                                        id="0-2-0-4" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="6、入离转调附件汇总"
                                        key="0-2-0-5"
                                        id="0-2-0-5" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、考勤管理细则"
                                    key="0-2-1"
                                    id="0-2-1" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、总则"
                                        key="0-2-1-0"
                                        id="0-2-1-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、考勤时间、打卡方法"
                                        key="0-2-1-1"
                                        id="0-2-1-1" className="siderNum"
                                    >

                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.1 考勤工作时间"
                                            key="0-2-1-1-0"
                                            id="0-2-1-1-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.2 考勤打卡、补卡方法"
                                            key="0-2-1-1-1"
                                            id="0-2-1-1-1" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、考勤奖惩机制"
                                        key="0-2-1-2"
                                        id="0-2-1-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、特殊考勤情况"
                                        key="0-2-1-3"
                                        id="0-2-1-3" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.1 出差"
                                            key="0-2-1-3-0"
                                            id="0-2-1-3-0" className="siderNum"
                                        /> 
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.2 外勤"
                                            key="0-2-1-3-1"
                                            id="0-2-1-3-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.3 驻站"
                                            key="0-2-1-3-2"
                                            id="0-2-1-3-2" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、其他说明"
                                        key="0-2-1-4"
                                        id="0-2-1-4" className="siderNum"
                                    />

                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、福利休假细则"
                                    key="0-2-2"
                                    id="0-2-2" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、总则"
                                        key="0-2-2-0"
                                        id="0-2-2-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、保险、休假、福利种类"
                                        key="0-2-2-1"
                                        id="0-2-2-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、保险、休假规定"
                                        key="0-2-2-2"
                                        id="0-2-2-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、休假待遇、安排"
                                        key="0-2-2-3"
                                        id="0-2-2-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、福利"
                                        key="0-2-2-4"
                                        id="0-2-2-4" className="siderNum"
                                    />

                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="四、劳动合同/人事档案管理细则"
                                    key="0-2-3"
                                    id="0-2-3" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、劳动合同管理细则"
                                        key="0-2-3-0"
                                        id="0-2-3-0" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.1 总则"
                                            key="0-2-3-0-0"
                                            id="0-2-3-0-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.2 劳动合同的订立、履行、变更"
                                            key="0-2-3-0-1"
                                            id="0-2-3-0-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.3 劳动合同终止和解除"
                                            key="0-2-3-0-2"
                                            id="0-2-3-0-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.4 劳动合同的日常管理"
                                            key="0-2-3-0-3"
                                            id="0-2-3-0-3" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.5 附则"
                                            key="0-2-3-0-4"
                                            id="0-2-3-0-4" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、人事档案管理细则"
                                        key="0-2-3-1"
                                        id="0-2-3-1" className="siderNum"
                                    />

                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="五、实习生管理规范"
                                    key="0-2-4"
                                    id="0-2-4" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、实习生需求报备"
                                        key="0-2-4-0"
                                        id="0-2-4-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、校企对接"
                                        key="0-2-4-1"
                                        id="0-2-4-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、接站、食宿安排"
                                        key="0-2-4-2"
                                        id="0-2-4-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、实习生报到、领用物资"
                                        key="0-2-4-3"
                                        id="0-2-4-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、保险"
                                        key="0-2-4-4"
                                        id="0-2-4-4" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="6、培训机制"
                                        key="0-2-4-5"
                                        id="0-2-4-5" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="7、分配"
                                        key="0-2-4-6"
                                        id="0-2-4-6" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="8、实习期考核"
                                        key="0-2-4-7"
                                        id="0-2-4-7" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="9、日常管理"
                                        key="0-2-4-8"
                                        id="0-2-4-8" className="siderNum"
                                    />

                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="六、办公系统操作规范"
                                    key="0-2-5"
                                    id="0-2-5" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、适用范围"
                                        key="0-2-5-0"
                                        id="0-2-5-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、使用原则"
                                        key="0-2-5-1"
                                        id="0-2-5-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、各板块使用流程及细则"
                                        key="0-2-5-2"
                                        id="0-2-5-2" className="siderNum"
                                    >
                                
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.1 人事板块"
                                            key="0-2-5-2-0"
                                            id="0-2-5-2-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.2 行政板块"
                                            key="0-2-5-2-1"
                                            id="0-2-5-2-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.3 后勤保障板块"
                                            key="0-2-5-2-2"
                                            id="0-2-5-2-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.4 积分制审批"
                                            key="0-2-5-2-3"
                                            id="0-2-5-2-3" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.5 财务板块"
                                            key="0-2-5-2-4"
                                            id="0-2-5-2-4" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.6 其他板块"
                                            key="0-2-5-2-5"
                                            id="0-2-5-2-5" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、远程办公管理制度（试运行）"
                                        key="0-2-5-3"
                                        id="0-2-5-3" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="七、九级能力划分法"
                                    key="0-2-6"
                                    id="0-2-6" className="siderNum"
                                />
                            </TreeNode>
                            {/*第四章*/}
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第四章 安全管理制度"
                                key="0-3"
                                id="0-3" className="siderNum"
                            >
                                
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="车辆安全管理细则"
                                    key="0-3-0"
                                    id="0-3-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、目的"
                                        key="0-3-0-0"
                                        id="0-3-0-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、适用范围"
                                        key="0-3-0-1"
                                        id="0-3-0-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、车辆管理部门职责"
                                        key="0-3-0-2"
                                        id="0-3-0-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、驾驶人职责"
                                        key="0-3-0-3"
                                        id="0-3-0-3" className="siderNum"
                                    />

                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、车辆保养及维修管理"
                                        key="0-3-0-4"
                                        id="0-3-0-4" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="6、车辆违章及事故处理"
                                        key="0-3-0-5"
                                        id="0-3-0-5" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、防火防盗安全细则 "
                                    key="0-3-1"
                                    id="0-3-1" className="siderNum"
                                >
                                    {/* <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、防火防盗管理细则"
                                        key="0-3-1-0"
                                        id="0-3-1-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、安全员管理制度"
                                        key="0-3-1-1"
                                        id="0-3-1-1" className="siderNum"
                                    /> */}
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、车间生产安全细则"
                                    key="0-3-2"
                                    id="0-3-2" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、汽车维修工作安全"
                                        key="0-3-2-0"
                                        id="0-3-2-0" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.1 工作环境的安全"
                                            key="0-3-2-0-0"
                                            id="0-3-2-0-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.2 个人安全防护"
                                            key="0-3-2-0-1"
                                            id="0-3-2-0-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.3 维修安全"
                                            key="0-3-2-0-2"
                                            id="0-3-2-0-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.4 汽车路试安全规则"
                                            key="0-3-2-0-3"
                                            id="0-3-2-0-3" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、维修工具设备的安全使用"
                                        key="0-3-2-1"
                                        id="0-3-2-1" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.1 一般维修工具的安全规则"
                                            key="0-3-2-1-0"
                                            id="0-3-2-1-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.2 维修设备的安全要求"
                                            key="0-3-2-1-1"
                                            id="0-3-2-1-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.3 车间安全用电和防火安全常识"
                                            key="0-3-2-1-2"
                                            id="0-3-2-1-2" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、汽车危险性废料处理"
                                        key="0-3-2-2"
                                        id="0-3-2-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、混合动力及纯电动车型维修安全规范"
                                        key="0-3-2-3"
                                        id="0-3-2-3" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.1 安全防护要求"
                                            key="0-3-2-3-0"
                                            id="0-3-2-3-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.2 安全维修操作规范"
                                            key="0-3-2-3-1"
                                            id="0-3-2-3-1" className="siderNum"
                                        />

                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、安全生产事故（事件）处理细则"
                                        key="0-3-2-4"
                                        id="0-3-2-4" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="四、网络安全管理细则"
                                    key="0-3-3"
                                    id="0-3-3" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、网络设备及信息安全管理细则"
                                        key="0-3-3-0"
                                        id="0-3-3-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、网络宣传管理细则"
                                        key="0-3-3-1"
                                        id="0-3-3-1" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="五、纪律检查委员会职责"
                                    key="0-3-4"
                                    id="0-3-4" className="siderNum"
                                >
                            </TreeNode>
                            </TreeNode>
                            {/*第五章*/}
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第五章 财务管理制度"
                                key="0-4"
                                id="0-4" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、报销制度管理细则及审批流程"
                                    key="0-4-0"
                                    id="0-4-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、费用报销管理细则"
                                        key="0-4-0-0"
                                        id="0-4-0-0" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.1 总则"
                                            key="0-4-0-0-0"
                                            id="0-4-0-0-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.2 费用报销规定细则"
                                            key="0-4-0-0-1"
                                            id="0-4-0-0-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.3 费用的分类"
                                            key="0-4-0-0-2"
                                            id="0-4-0-0-2" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、费用报销审批流程"
                                        key="0-4-0-1"
                                        id="0-4-0-1" className="siderNum"
                                    />


                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、应收应付账款管理细则"
                                    key="0-4-1"
                                    id="0-4-1" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、总则"
                                        key="0-4-1-0"
                                        id="0-4-1-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、客户资信管理"
                                        key="0-4-1-1"
                                        id="0-4-1-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、产品赊销管理"
                                        key="0-4-1-2"
                                        id="0-4-1-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、应收账款监控制度"
                                        key="0-4-1-3"
                                        id="0-4-1-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、坏账管理制度"
                                        key="0-4-1-4"
                                        id="0-4-1-4" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="6、应付账款管理"
                                        key="0-4-1-5"
                                        id="0-4-1-6" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、审计稽核细则"
                                    key="0-4-2"
                                    id="0-4-2" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、总则"
                                        key="0-4-2-0"
                                        id="0-4-2-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、内部审计的范围和内容"
                                        key="0-4-2-1"
                                        id="0-4-2-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、内部审计工作程序和注意事项"
                                        key="0-4-2-2"
                                        id="0-4-2-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、审计档案管理"
                                        key="0-4-2-3"
                                        id="0-4-2-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、奖励与处罚"
                                        key="0-4-2-4"
                                        id="0-4-2-4" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="四、印章管理细则"
                                    key="0-4-3"
                                    id="0-4-3" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、印章的刻制和启用"
                                        key="0-4-3-0"
                                        id="0-4-3-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、印章的保管、交接和停用"
                                        key="0-4-3-1"
                                        id="0-4-3-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、印章使用"
                                        key="0-4-3-2"
                                        id="0-4-3-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、违纪处理"
                                        key="0-4-3-3"
                                        id="0-4-3-3" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="五、合同管理细则"
                                    key="0-4-4"
                                    id="0-4-4" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、总则"
                                        key="0-4-4-0"
                                        id="0-4-4-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、审查批准"
                                        key="0-4-4-1"
                                        id="0-4-4-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、合同签订"
                                        key="0-4-4-2"
                                        id="0-4-4-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、合同履行"
                                        key="0-4-4-3"
                                        id="0-4-4-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、合同变更、解除"
                                        key="0-4-4-4"
                                        id="0-4-4-4" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="6、纠纷处理"
                                        key="0-4-4-5"
                                        id="0-4-4-5" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="7、合同管理"
                                        key="0-4-4-6"
                                        id="0-4-4-6" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="六、现金、支票、发票管理细则"
                                    key="0-4-7"
                                    id="0-4-7" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、现金管理细则"
                                        key="0-4-7-0"
                                        id="0-4-7-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、支票管理细则"
                                        key="0-4-7-1"
                                        id="0-4-7-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、发票管理细则"
                                        key="0-4-7-2"
                                        id="0-4-7-2" className="siderNum"
                                    />
                                </TreeNode>

                            </TreeNode>
                        
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第六章 营销管理制度"
                                key="0-5"
                                id="0-5" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、通用条款（适用于集团公司各单位）"
                                    key="0-5-0"
                                    id="0-5-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、规定作业管理细则"
                                        key="0-5-0-1"
                                        id="0-5-0-1" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.1 月会、周会、晨夕会管理细则"
                                            key="0-5-0-1-0"
                                            id="0-5-0-1-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.2 日报、周报、月报管理细则"
                                            key="0-5-0-1-1"
                                            id="0-5-0-1-1" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、销售逻辑链及鱼池理论解析"
                                        key="0-5-0-2"
                                        id="0-5-0-2" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.1 销售技巧解析"
                                            key="0-5-0-2-0"
                                            id="0-5-0-2-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.2 销售逻辑链"
                                            key="0-5-0-2-1"
                                            id="0-5-0-2-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.3 鱼池理论解析"
                                            key="0-5-0-2-2"
                                            id="0-5-0-2-2" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、客户接洽和拜访跟进管理流程及标准"
                                        key="0-5-0-3"
                                        id="0-5-0-3" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.1 客户接洽流程及标准"
                                            key="0-5-0-3-0"
                                            id="0-5-0-3-0" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.1.1 客户接洽形象管理"
                                                key="0-5-0-3-0-0"
                                                id="0-5-0-3-0-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.1.2 接洽前准备工作"
                                                key="0-5-0-3-0-1"
                                                id="0-5-0-3-0-1" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.1.3 电话接洽"
                                                key="0-5-0-3-0-2"
                                                id="0-5-0-3-0-2" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.1.4 上门拜访"
                                                key="0-5-0-3-0-3"
                                                id="0-5-0-3-0-3" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.1.5 接洽标准"
                                                key="0-5-0-3-0-4"
                                                id="0-5-0-3-0-4" className="siderNum"
                                            />
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.2 客户拜访跟进说明"
                                            key="0-5-0-3-1"
                                            id="0-5-0-3-1" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.2.1 行业客户分析"
                                                key="0-5-0-3-1-0"
                                                id="0-5-0-3-1-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.2.2 联系方式"
                                                key="0-5-0-3-1-1"
                                                id="0-5-0-3-1-1" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.2.3 预约方式方法"
                                                key="0-5-0-3-1-2"
                                                id="0-5-0-3-1-2" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.2.4 拜访前准备资料"
                                                key="0-5-0-3-1-3"
                                                id="0-5-0-3-1-3" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.2.5 面访交流"
                                                key="0-5-0-3-1-4"
                                                id="0-5-0-3-1-4" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.2.6 后续跟进"
                                                key="0-5-0-3-1-5"
                                                id="0-5-0-3-1-5" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.2.7 报价"
                                                key="0-5-0-3-1-6"
                                                id="0-5-0-3-1-6" className="siderNum"
                                            />
                                        </TreeNode>

                                    </TreeNode>

                                    <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4、招投标细则及标准"
                                            key="0-5-0-4"
                                            id="0-5-0-4" className="siderNum"
                                        />
                                    
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、公司重大活动/会议的规范细则"
                                        key="0-5-0-5"
                                        id="0-5-0-5" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.1 成立工作组"
                                            key="0-5-0-5-0"
                                            id="0-5-0-5-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.2 信息确认"
                                            key="0-5-0-5-1"
                                            id="0-5-0-5-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.3 场地、物资安排"
                                            key="0-5-0-5-2"
                                            id="0-5-0-5-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.4 车辆安排"
                                            key="0-5-0-5-3"
                                            id="0-5-0-5-3" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.5 住宿安排"
                                            key="0-5-0-5-4"
                                            id="0-5-0-5-4" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.6 用餐安排"
                                            key="0-5-0-5-5"
                                            id="0-5-0-5-5" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.7 资料管理"
                                            key="0-5-0-5-6"
                                            id="0-5-0-5-6" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.8 风险保障"
                                            key="0-5-0-5-7"
                                            id="0-5-0-5-7" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.9 纪律要求"
                                            key="0-5-0-5-8"
                                            id="0-5-0-5-8" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.10 违规处理"
                                            key="0-5-0-5-9"
                                            id="0-5-0-5-9" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.11 礼仪要求"
                                            key="0-5-0-5-10"
                                            id="0-5-0-5-10" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.12 后续处理工作（会后）"
                                            key="0-5-0-5-11"
                                            id="0-5-0-5-11" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode 
                                        icon={<Icon type="carry-out"/>}
                                        title="6、全员换岗学习"
                                        key="0-5-0-6"
                                        id="0-5-0-6" className="siderNum"
                                    />
                                         <TreeNode 
                                        icon={<Icon type="carry-out"/>}
                                        title="7、职业装管理细则"
                                        key="0-5-0-7"
                                        id="0-5-0-7" className="siderNum"
                                    />
                                       <TreeNode 
                                        icon={<Icon type="carry-out"/>}
                                        title="8、精品管理细则"
                                        key="0-5-0-8"
                                        id="0-5-0-8" className="siderNum"
                                    />

                                </TreeNode>
                           

                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、专用条款 （各营销机构内部管控流程及标准）"
                                    key="0-5-1"
                                    id="0-5-1" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、卡车业务管理公司"
                                        key="0-5-1-0"
                                        id="0-5-1-0" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.1 2021年组织机构图及人事安排"
                                            key="0-5-1-0-0"
                                            id="0-5-1-0-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.2卡车公司岗位职责及业务范围"
                                            key="0-5-1-0-1"
                                            id="0-5-1-0-1" className="siderNum"
                                        />
                                         
                                        
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.3 卡车公司通用管理规定"
                                            key="0-5-1-0-2"
                                            id="0-5-1-0-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.4 卡车公司销售绩效细则"
                                            key="0-5-1-0-3"
                                            id="0-5-1-0-3" className="siderNum"
                                        >
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.5 卡车公司售后服务收入细则"
                                            key="0-5-1-0-4"
                                            id="0-5-1-0-4" className="siderNum"
                                        >
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.6 卡车公司差旅积分细则"
                                            key="0-5-1-0-5"
                                            id="0-5-1-0-5" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、客车业务管理公司"
                                        key="0-5-1-1"
                                        id="0-5-1-1" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.1 2020年组织机构图及人事安排"
                                            key="0-5-1-1-0"
                                            id="0-5-1-1-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.2 客车公司各科室职能及作业流程标准"
                                            key="0-5-1-1-1"
                                            id="0-5-1-1-1" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、云豪车服管理公司"
                                        key="0-5-1-2"
                                        id="0-5-1-2" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.1 2020年组织机构图及人事安排"
                                            key="0-5-1-2-0"
                                            id="0-5-1-2-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.2 云豪车服各部室职能及岗位职责"
                                            key="0-5-1-2-1"
                                            id="0-5-1-2-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.3 云豪车服内部管控流程及标准"
                                            key="0-5-1-2-2"
                                            id="0-5-1-2-2" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.3.1 云豪车服各部室管理细则"
                                                key="0-5-1-2-2-0"
                                                id="0-5-1-2-2-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.3.2 24小时值班轮岗、备岗"
                                                key="0-5-1-2-2-1"
                                                id="0-5-1-2-2-1" className="siderNum"
                                            />

                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.3.3 安全驾驶激励政策"
                                                key="0-5-1-2-2-2"
                                                id="0-5-1-2-2-2" className="siderNum"
                                            />

                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.3.4 执行力"
                                                key="0-5-1-2-2-3"
                                                id="0-5-1-2-2-3" className="siderNum"
                                            />
                                        </TreeNode>

                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.4 云豪车服收入分配细则"
                                            key="0-5-1-2-3"
                                            id="0-5-1-2-3" className="siderNum"
                                            
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.4.1 绩效提成"
                                                key="0-5-1-2-3-0"
                                                id="0-5-1-2-3-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.4.2 维修事故考核标准"
                                                key="0-5-1-2-3-1"
                                                id="0-5-1-2-3-1" className="siderNum"
                                            />
                                         <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.4.3 维修技能等级标准"
                                                key="0-5-1-2-3-2"
                                                id="0-5-1-2-3-2" className="siderNum"
                                            />
                                                
                                    </TreeNode>
                                     

                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.5 云豪车服专用条款作业流程"
                                            key="0-5-1-2-4"
                                            id="0-5-1-2-4" className="siderNum"
                                        >
                                        <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.5.1 车险业务作业流程"
                                                key="0-5-1-2-4-0"
                                                id="0-5-1-2-4-0" className="siderNum"
                                            />
                                        <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.5.2 全员事故车业务激励办法"
                                                key="0-5-1-2-4-1"
                                                id="0-5-1-2-4-1" className="siderNum"
                                            />

                                         </TreeNode>


                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.6 云豪创业空间--创业班组试运行方案及管理细则"
                                            key="0-5-1-2-5"
                                            id="0-5-1-2-5" className="siderNum"
                                        >
                                        <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.6.1 创业班组试运行方案"
                                                key="0-5-1-2-5-0"
                                                id="0-5-1-2-5-0" className="siderNum"
                                            />
                                         <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="3.6.2 创业班组管理细则"
                                                key="0-5-1-2-5-1"
                                                id="0-5-1-2-5-1" className="siderNum"
                                            />

                                        </TreeNode>

                                        {/* <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.7 安全驾驶激励政策"
                                            key="0-5-1-2-6"
                                            id="0-5-1-2-6" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="3.8 全员销售奖励机制"
                                            key="0-5-1-2-7"
                                            id="0-5-1-2-7" className="siderNum"
                                        /> */}
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、云豪备品管理公司"
                                        key="0-5-1-3"
                                        id="0-5-1-3" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.1 2020年组织机构图及人事安排"
                                            key="0-5-1-3-0"
                                            id="0-5-1-3-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.2 云豪备品管理公司内部管控细则"
                                            key="0-5-1-3-1"
                                            id="0-5-1-3-1" className="siderNum"
                                            >
                                            <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.2.1 计划部"
                                            key="0-5-1-3-1-0"
                                            id="0-5-1-3-1-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.2.2 销售配件索赔"
                                            key="0-5-1-3-1-1"
                                            id="0-5-1-3-1-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.2.3 质量检验"
                                            key="0-5-1-3-1-2"
                                            id="0-5-1-3-1-2" className="siderNum"

                                            />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.2.4 物资安全"
                                            key="0-5-1-3-1-3"
                                            id="0-5-1-3-1-3" className="siderNum"

                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="4.2.5 新员工入职"
                                                key="0-5-1-3-1-4"
                                                id="0-5-1-3-1-4" className="siderNum"
                                            
                                            />
                                            <TreeNode
                                                    icon={<Icon type="carry-out"/>}
                                                    title="4.2.6 培训"
                                                    key="0-5-1-3-1-5"
                                                    id="0-5-1-3-1-5" className="siderNum"
                                             />
                                            <TreeNode
                                                    icon={<Icon type="carry-out"/>}
                                                    title="4.2.7 网络营销"
                                                    key="0-5-1-3-1-6"
                                                    id="0-5-1-3-1-6" className="siderNum"

                                            />
                                            <TreeNode
                                                    icon={<Icon type="carry-out"/>}
                                                    title="4.2.8 市场部作业流程及标准"
                                                    key="0-5-1-3-1-7"
                                                    id="0-5-1-3-1-7" className="siderNum"

                                            />
                                            <TreeNode
                                                    icon={<Icon type="carry-out"/>}
                                                    title="4.2.9 销售支持科业务流程及标准"
                                                    key="0-5-1-3-1-8"
                                                    id="0-5-1-3-1-8" className="siderNum"
                                            />
                                        </TreeNode>
                                        
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.3 配件营销绩效方案细则"
                                            key="0-5-1-3-2"
                                            id="0-5-1-3-2" className="siderNum"
                                        />
                                    </TreeNode>

                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、制造业管理公司"
                                        key="0-5-1-4"
                                        id="0-5-1-4" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="5.1 2020年组织机构图及人事安排"
                                            key="0-5-1-4-0"
                                            id="0-5-1-4-0" className="siderNum"
                                        />

                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="6、海外业务管理公司"
                                        key="0-5-1-5"
                                        id="0-5-1-5" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="6.1 2020年组织机构图及人事安排"
                                            key="0-5-1-5-0"
                                            id="0-5-1-5-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="6.2 海外公司各部门职能"
                                            key="0-5-1-5-1"
                                            id="0-5-1-5-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="6.3 海外公司内部管控细则"
                                            key="0-5-1-5-2"
                                            id="0-5-1-5-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="6.4 海外公司各部门业务流程细则"
                                            key="0-5-1-5-3"
                                            id="0-5-1-5-3" className="siderNum"
                                        />

                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="7、电商中心"
                                        key="0-5-1-6"
                                        id="0-5-1-6" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="7.1 电商中心组织机构图及人事安排"
                                            key="0-5-1-6-0"
                                            id="0-5-1-6-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="7.2 电商中心2020年任务指标"
                                            key="0-5-1-6-1"
                                            id="0-5-1-6-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="7.3 内部管控流程及执行标准"
                                            key="0-5-1-6-2"
                                            id="0-5-1-6-2" className="siderNum"
                                        >  
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="7.3.1 统计部"
                                                key="0-5-1-6-2-0"
                                                id="0-5-1-6-2-0" className="siderNum"
                                            /> 
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="7.3.2 技术部"
                                                key="0-5-1-6-2-1"
                                                id="0-5-1-6-2-1" className="siderNum"
                                            /> 
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="7.3.3 网络营销事业部"
                                                key="0-5-1-6-2-2"
                                                id="0-5-1-6-2-2" className="siderNum"
                                            /> 
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="7.3.4 孵化项目部"
                                                key="0-5-1-6-2-3"
                                                id="0-5-1-6-2-3" className="siderNum"
                                            /> 
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="7.4 电商中心人员岗位职责"
                                            key="0-5-1-6-3"
                                            id="0-5-1-6-3" className="siderNum"
                                        />  
                                    </TreeNode>
                                </TreeNode>

                            </TreeNode>
                            {/*第七章*/}
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第七章 生产管理制度"
                                key="0-6"
                                id="0-6" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、通用条款"
                                    key="0-6-0"
                                    id="0-6-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、车间物业管理细则 细则"
                                        key="0-6-0-0"
                                        id="0-6-0-0" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.1 设备"
                                            key="0-6-0-0-0"
                                            id="0-6-0-0-0" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.1.1 设备需求"
                                                key="0-6-0-0-0-0"
                                                id="0-6-0-0-0-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.1.2 设备使用规范"
                                                key="0-6-0-0-0-1"
                                                id="0-6-0-0-0-1" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.1.3 设备管理及维护制度"
                                                key="0-6-0-0-0-2"
                                                id="0-6-0-0-0-2" className="siderNum"
                                            />
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.2 工具"
                                            key="0-6-0-0-1"
                                            id="0-6-0-0-1" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.2.1 人手工具"
                                                key="0-6-0-0-1-0"
                                                id="0-6-0-0-1-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.2.2 分队工具"
                                                key="0-6-0-0-1-1"
                                                id="0-6-0-0-1-1" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.2.3 通用工具"
                                                key="0-6-0-0-1-2"
                                                id="0-6-0-0-1-2" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.2.4 专用工具"
                                                key="0-6-0-0-1-3"
                                                id="0-6-0-0-1-3" className="siderNum"
                                            />
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.3 叉车"
                                            key="0-6-0-0-2"
                                            id="0-6-0-0-0-2" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.3.1 检查车辆"
                                                key="0-6-0-0-2-0"
                                                id="0-6-0-0-0-2-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.3.2 起步"
                                                key="0-6-0-0-2-1"
                                                id="0-6-0-0-0-2-1" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.3.3 行驶"
                                                key="0-6-0-0-2-2"
                                                id="0-6-0-0-0-2-2" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.3.4 装卸"
                                                key="0-6-0-0-2-3"
                                                id="0-6-0-0-0-2-3" className="siderNum"
                                            />
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.4 场地"
                                            key="0-6-0-0-3"
                                            id="0-6-0-0-0-3" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.4.1 区域管理"
                                                key="0-6-0-0-3-0"
                                                id="0-6-0-0-3-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.4.2 标识管理"
                                                key="0-6-0-0-3-1"
                                                id="0-6-0-0-3-1" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.4.3 环境管理"
                                                key="0-6-0-0-3-2"
                                                id="0-6-0-0-3-2" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.4.4 车间办公室管理"
                                                key="0-6-0-0-3-3"
                                                id="0-6-0-0-3-3" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.4.5 职业形象管理"
                                                key="0-6-0-0-3-4"
                                                id="0-6-0-0-3-4" className="siderNum"
                                            />
                                        </TreeNode>
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、车间作业流程细则"
                                        key="0-6-0-1"
                                        id="0-6-0-1" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.1 车间作业流程"
                                            key="0-6-0-1-0"
                                            id="0-6-0-1-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.2 车间作业流程规范"
                                            key="0-6-0-1-1"
                                            id="0-6-0-1-1" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、车间维护保养作业标准"
                                        key="0-6-0-2"
                                        id="0-6-0-2" className="siderNum"
                                    />

                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、师徒制管理细则"
                                        key="0-6-0-3"
                                        id="0-6-0-3" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.1 师徒身份的标准"
                                            key="0-6-0-3-0"
                                            id="0-6-0-3-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.2 师徒关系的确定"
                                            key="0-6-0-3-1"
                                            id="0-6-0-3-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.3 师傅的责任与权利"
                                            key="0-6-0-3-2"
                                            id="0-6-0-3-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.4 徒弟的责任及权利"
                                            key="0-6-0-3-3"
                                            id="0-6-0-3-3" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、配件库房管理细则"
                                        key="0-6-0-4"
                                        id="0-6-0-4" className="siderNum"
                                    />
                                </TreeNode>

                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、专用条款"
                                    key="0-6-1"
                                    id="0-6-1" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、卡车业务管理公司 细则"
                                        key="0-6-1-0"
                                        id="0-6-1-0" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.1 内部运转流程"
                                            key="0-6-1-0-0"
                                            id="0-6-1-0-0" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.1.1 客户预约"
                                                key="0-6-1-0-0-0"
                                                id="0-6-1-0-0-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.1.2 服务顾问"
                                                key="0-6-1-0-0-1"
                                                id="0-6-1-0-0-1" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.1.3 服务顾问：站内维修接待"
                                                key="0-6-1-0-0-2"
                                                id="0-6-1-0-0-2" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.1.4 服务顾问：站外维修预约"
                                                key="0-6-1-0-0-3"
                                                id="0-6-1-0-0-3" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.1.5 生产车间"
                                                key="0-6-1-0-0-4"
                                                id="0-6-1-0-0-4" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.1.6 服务顾问"
                                                key="0-6-1-0-0-5"
                                                id="0-6-1-0-0-5" className="siderNum"
                                            />
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.2 三包索赔业务及相关工作要求"
                                            key="0-6-1-0-1"
                                            id="0-6-1-0-1" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.2.1 服务顾问-索赔部"
                                                key="0-6-1-0-1-0"
                                                id="0-6-1-0-1-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.2.2 维修公司-索赔部"
                                                key="0-6-1-0-1-1"
                                                id="0-6-1-0-1-1" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="1.2.3 索赔部-零件仓储"
                                                key="0-6-1-0-1-2"
                                                id="0-6-1-0-1-2" className="siderNum"
                                            />
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.3 车间生产管理"
                                            key="0-6-1-0-2"
                                            id="0-6-1-0-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.4 卡车公司生产管理各项表格模板"
                                            key="0-6-1-0-3"
                                            id="0-6-1-0-3" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、云豪车服管理公司/天津服务公司 细则"
                                        key="0-6-1-1"
                                        id="0-6-1-1" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.1 关于法士特/欧辉/欧曼/重汽的服务管理办法"
                                            key="0-6-1-1-0"
                                            id="0-6-1-1-0" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="2.1.1 法士特索赔要求"
                                                key="0-6-1-1-0-0"
                                                id="0-6-1-1-0-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="2.1.2 欧辉服务要求"
                                                key="0-6-1-1-0-1"
                                                id="0-6-1-1-0-1" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="2.1.3 欧曼服务要求"
                                                key="0-6-1-1-0-2"
                                                id="0-6-1-1-0-2" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="2.1.4 关于重汽服务要求"
                                                key="0-6-1-1-0-3"
                                                id="0-6-1-1-0-3" className="siderNum"
                                            />
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.2 陕汽/潍柴工时系数服务要求"
                                            key="0-6-1-1-1"
                                            id="0-6-1-1-1" className="siderNum"
                                        >
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="2.2.1 陕汽工时系数服务要求"
                                                key="0-6-1-1-1-0"
                                                id="0-6-1-1-1-0" className="siderNum"
                                            />
                                            <TreeNode
                                                icon={<Icon type="carry-out"/>}
                                                title="2.2.2 潍柴工时系数要求"
                                                key="0-6-1-1-1-1"
                                                id="0-6-1-1-1-1" className="siderNum"
                                            />
                                        </TreeNode>
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.3 云豪车服对内/对外收费工时标准"
                                            key="0-6-1-1-2"
                                            id="0-6-1-1-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.4 云豪车服服务承诺"
                                            key="0-6-1-1-3"
                                            id="0-6-1-1-3" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.5 云豪车服生产管理各项表格模��"
                                            key="0-6-1-1-4"
                                            id="0-6-1-1-4" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、客车业务管理公司 细则"
                                        key="0-6-1-2"
                                        id="0-6-1-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、云豪备品管理公司"
                                        key="0-6-1-3"
                                        id="0-6-1-3" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="4.1 仓储物流表格模板"
                                            key="0-6-1-3-0"
                                            id="0-6-1-3-0" className="siderNum"
                                        />

                                    </TreeNode>
                                </TreeNode>
                            </TreeNode>
                            {/*第八章*/}
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第八章 技术管理制度"
                                key="0-7"
                                id="0-7" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、技术资料/档案管理细则"
                                    key="0-7-0"
                                    id="0-7-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、总则"
                                        key="0-7-0-0"
                                        id="0-7-0-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、技术文件的归档"
                                        key="0-7-0-1"
                                        id="0-7-0-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、技术中心的任务和管理人员的职责"
                                        key="0-7-0-2"
                                        id="0-7-0-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、档案保管和借阅"
                                        key="0-7-0-3"
                                        id="0-7-0-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、档案复制和资料的发放"
                                        key="0-7-0-4"
                                        id="0-7-0-4" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、设计和开发管理流程"
                                    key="0-7-1"
                                    id="0-7-1" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、职责"
                                        key="0-7-1-0"
                                        id="0-7-1-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、工作程序"
                                        key="0-7-1-1"
                                        id="0-7-1-1" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.1 设计和开发项目提出"
                                            key="0-7-1-1-0"
                                            id="0-7-1-1-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.2 设计和开发输入"
                                            key="0-7-1-1-1"
                                            id="0-7-1-1-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.3 设计和开发输出"
                                            key="0-7-1-1-2"
                                            id="0-7-1-1-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.4 设计评审"
                                            key="0-7-1-1-3"
                                            id="0-7-1-1-3" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.5 设计验证"
                                            key="0-7-1-1-4"
                                            id="0-7-1-1-4" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.6 设计确认、存档"
                                            key="0-7-1-1-5"
                                            id="0-7-1-1-5" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、相关文件、计划书、报告模板"
                                        key="0-7-1-2"
                                        id="0-7-1-2" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、维护保养作业切块工艺管理规范"
                                    key="0-7-2"
                                    id="0-7-2" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、发动机"
                                        key="0-7-2-0"
                                        id="0-7-2-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、冷却系统"
                                        key="0-7-2-1"
                                        id="0-7-2-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、燃油、后处理系统"
                                        key="0-7-2-2"
                                        id="0-7-2-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、新能源车"
                                        key="0-7-2-3"
                                        id="0-7-2-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、离合器系统"
                                        key="0-7-2-4"
                                        id="0-7-2-4" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="6、变速箱"
                                        key="0-7-2-5"
                                        id="0-7-2-5" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="7、传动轴总成"
                                        key="0-7-2-6"
                                        id="0-7-2-6" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="8、前桥"
                                        key="0-7-2-7"
                                        id="0-7-2-7" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="9、后桥"
                                        key="0-7-2-8"
                                        id="0-7-2-8" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="10、制动系统"
                                        key="0-7-2-9"
                                        id="0-7-2-9" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="11、悬挂系统"
                                        key="0-7-2-10"
                                        id="0-7-2-10" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="12、专项系统"
                                        key="0-7-2-11"
                                        id="0-7-2-11" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="13、电器系统"
                                        key="0-7-2-12"
                                        id="0-7-2-12" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="14、仪表仪器"
                                        key="0-7-2-13"
                                        id="0-7-2-13" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="15、驾驶操作系统"
                                        key="0-7-2-14"
                                        id="0-7-2-14" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="16、底盘保养与及测"
                                        key="0-7-2-15"
                                        id="0-7-2-15" className="siderNum"
                                    />
                                </TreeNode>
                            </TreeNode>
                            {/*第九章*/}
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第九章 培训管理制度"
                                key="0-8"
                                id="0-8" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、云豪学院组织机构、人事安排及科室作业规范"
                                    key="0-8-0"
                                    id="0-8-0" className="siderNum"
                                >
                                     <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、组织构架"
                                        key="0-8-0-0"
                                        id="0-8-0-0" className="siderNum"
                                    />
                                    
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、人事安排"
                                        key="0-8-0-1"
                                        id="0-8-0-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、科室作业规范"
                                        key="0-8-0-2"
                                        id="0-8-0-2" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、培训资料/档案管理规范"
                                    key="0-8-1"
                                    id="0-8-1" className="siderNum"
                                />
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、培训考核及证书颁发标准"
                                    key="0-8-2"
                                    id="0-8-2" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、精英训练营证书考核及颁发标准"
                                        key="0-8-2-0"
                                        id="0-8-2-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、讲师证考核及证书颁发标准"
                                        key="0-8-2-1"
                                        id="0-8-2-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、工匠证等其他证书的考核及颁发标准"
                                        key="0-8-2-2"
                                        id="0-8-2-2" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="四、讲师管理细则"
                                    key="0-8-3"
                                    id="0-8-3" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、内部讲师的选拔"
                                        key="0-8-3-0"
                                        id="0-8-3-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、外聘讲师的标准"
                                        key="0-8-3-1"
                                        id="0-8-3-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、内部讲师的职业素养与纪律要求"
                                        key="0-8-3-2"
                                        id="0-8-3-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、讲师的激励"
                                        key="0-8-3-3"
                                        id="0-8-3-3" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="五、学员管理细则"
                                    key="0-8-4"
                                    id="0-8-4" className="siderNum"
                                />
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="六、管理中心/公司培训配合细则"
                                    key="0-8-5"
                                    id="0-8-5" className="siderNum"
                                />
                            </TreeNode>
                            {/*第十章*/}
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第十章 后勤保障制度"
                                key="0-9"
                                id="0-9" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、员工宿舍管理条例"
                                    key="0-9-0"
                                    id="0-9-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、有偿住宿标准"
                                        key="0-9-0-0"
                                        id="0-9-0-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、申请住宿要求"
                                        key="0-9-0-1"
                                        id="0-9-0-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、宿舍卫生管理细则"
                                        key="0-9-0-2"
                                        id="0-9-0-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、宿舍规定及处罚条例"
                                        key="0-9-0-3"
                                        id="0-9-0-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、消防安全管理"
                                        key="0-9-0-4"
                                        id="0-9-0-4" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="6、宿舍来访出入规定"
                                        key="0-9-0-5"
                                        id="0-9-0-5" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="7、宿舍积分考核"
                                        key="0-9-0-6"
                                        id="0-9-0-6" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、职工食堂管理细则"
                                    key="0-9-1"
                                    id="0-9-1" className="siderNum"
                                >

                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、目的"
                                        key="0-9-1-0"
                                        id="0-9-1-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、食堂管理规范"
                                        key="0-9-1-1"
                                        id="0-9-1-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、食堂服务团队管理细则"
                                        key="0-9-1-2"
                                        id="0-9-1-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、就餐员工管理细则"
                                        key="0-9-1-3"
                                        id="0-9-1-3" className="siderNum"
                                    />
                                       <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、垃圾分类管理细则"
                                        key="0-9-1-4"
                                        id="0-9-1-4" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、基础设施管理细则"
                                    key="0-9-2"
                                    id="0-9-2" className="siderNum"
                                />
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="四、车辆使用管理细则"
                                    key="0-9-3"
                                    id="0-9-3" className="siderNum"
                                />
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="五、公用场所管理细则"
                                    key="0-9-4"
                                    id="0-9-4" className="siderNum"
                                />

                            </TreeNode>
                      
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第十一章 采购管理制度"
                                key="0-10"
                                id="0-10" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、集团公司集中采购管理制度"
                                    key="0-10-0"
                                    id="0-10-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、总则"
                                        key="0-10-0-0"
                                        id="0-10-0-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、集中采购流程"
                                        key="0-10-0-1"
                                        id="0-10-0-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、部门职责"
                                        key="0-10-0-2"
                                        id="0-10-0-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、采购方式"
                                        key="0-10-0-3"
                                        id="0-10-0-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、通用物资集中采购目录"
                                        key="0-10-0-4"
                                        id="0-10-0-4" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="6、专用物资的采购流程"
                                        key="0-10-0-5"
                                        id="0-10-0-5" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="7、采购物资库存控制"
                                        key="0-10-0-6"
                                        id="0-10-0-6" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="8、附则"
                                        key="0-10-0-7"
                                        id="0-10-0-7" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、生活物资采购流程"
                                    key="0-10-1"
                                    id="0-10-1" className="siderNum"
                                />
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、生产物资采购流程 "
                                    key="0-10-2"
                                    id="0-10-2" className="siderNum"
                                />
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="四、供应商管理细则"
                                    key="0-10-3"
                                    id="0-10-3" className="siderNum"
                                />
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="五、采购计划表范本"
                                    key="0-10-4"
                                    id="0-10-4" className="siderNum"
                                />

                            </TreeNode>
                            {/*第十二章*/}
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第十二章 质检管理制度"
                                key="0-11"
                                id="0-11" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、车辆竣工检验流程及标准"
                                    key="0-11-0"
                                    id="0-11-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、车辆竣工检验流程"
                                        key="0-11-0-0"
                                        id="0-11-0-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、车辆竣工具体标准"
                                        key="0-11-0-1"
                                        id="0-11-0-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、未通过质检车辆的处理环节"
                                        key="0-11-0-2"
                                        id="0-11-0-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、内部返修的处理环节"
                                        key="0-11-0-3"
                                        id="0-11-0-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、监管"
                                        key="0-11-0-4"
                                        id="0-11-0-4" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、新车交车检验流程及标准"
                                    key="0-11-1"
                                    id="0-11-1" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、接车检查"
                                        key="0-11-1-0"
                                        id="0-11-1-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、新车交车检验流程"
                                        key="0-11-1-1"
                                        id="0-11-1-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、交车过程中规范"
                                        key="0-11-1-2"
                                        id="0-11-1-2" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、配件出入库检验流程及标准"
                                    key="0-11-2"
                                    id="0-11-2" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、配件入库检验流程"
                                        key="0-11-2-0"
                                        id="0-11-2-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、配件出库检验流程"
                                        key="0-11-2-1"
                                        id="0-11-2-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、配件出库标准"
                                        key="0-11-2-2"
                                        id="0-11-2-2" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="四、客户意见/投诉处理细则 "
                                    key="0-11-3"
                                    id="0-11-3" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、目的"
                                        key="0-11-3-0"
                                        id="0-11-3-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、客户投诉／需求的定义及具体内容"
                                        key="0-11-3-1"
                                        id="0-11-3-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、有效投诉的等级分类"
                                        key="0-11-3-2"
                                        id="0-11-3-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、投诉处理程序"
                                        key="0-11-3-3"
                                        id="0-11-3-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、投诉处理规范"
                                        key="0-11-3-4"
                                        id="0-11-3-4" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="五、内部稽查管理细则 "
                                    key="0-11-4"
                                    id="0-11-4" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、稽查制度执行领导组成员、职责及权限"
                                        key="0-11-4-0"
                                        id="0-11-4-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、操作方法"
                                        key="0-11-4-1"
                                        id="0-11-4-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、检查内容"
                                        key="0-11-4-2"
                                        id="0-11-4-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、稽查报告及整改"
                                        key="0-11-4-3"
                                        id="0-11-4-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、考核细则"
                                        key="0-11-4-4"
                                        id="0-11-4-4" className="siderNum"
                                    />

                                </TreeNode>

                            </TreeNode>
                            {/*第十三章*/}
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第十三章 仓储物流管理制度"
                                key="0-12"
                                id="0-12" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、车辆或配件入库流程"
                                    key="0-12-0"
                                    id="0-12-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、车辆入库流程"
                                        key="0-12-0-0"
                                        id="0-12-0-0" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、车辆或配件搬运、移动、存储管理标准"
                                    key="0-12-1"
                                    id="0-12-1" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、车辆移动、存储管理流程"
                                        key="0-12-1-0"
                                        id="0-12-1-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、配件搬运、移动管理标准"
                                        key="0-12-1-1"
                                        id="0-12-1-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、配件存储管理标准"
                                        key="0-12-1-2"
                                        id="0-12-1-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、卡车公司配件入库流程"
                                        key="0-12-1-3"
                                        id="0-12-1-3" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="5、配件公司入库流程"
                                        key="0-12-1-4"
                                        id="0-12-1-4" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、车辆或配件出库流程及标准"
                                    key="0-12-2"
                                    id="0-12-2" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、车辆出库流程"
                                        key="0-12-2-0"
                                        id="0-12-2-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、卡车公司配件出库流程"
                                        key="0-12-2-1"
                                        id="0-12-2-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、配件公司配件出库流程"
                                        key="0-12-2-2"
                                        id="0-12-2-2" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="四、不良品管理细则（残次品、积压品）"
                                    key="0-12-3"
                                    id="0-12-3" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、目的、适用范围、责权部门"
                                        key="0-12-3-0"
                                        id="0-12-3-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、不良品的定义"
                                        key="0-12-3-1"
                                        id="0-12-3-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、不良品管理规定"
                                        key="0-12-3-2"
                                        id="0-12-3-2" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="4、不良品的检验流程及处理规定"
                                        key="0-12-3-3"
                                        id="0-12-3-3" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="五、盘点管理细则"
                                    key="0-12-4"
                                    id="0-12-4" className="siderNum"
                                />
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="六、各项表格范本"
                                    key="0-12-5"
                                    id="0-12-5" className="siderNum"
                                />

                            </TreeNode>
                            {/*第十四章*/}
                            <TreeNode
                                icon={<Icon type="carry-out"/>}
                                title="第十四章 设备管理制度"
                                key="0-13"
                                id="0-13" className="siderNum"
                            >
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="一、重点设备使用规范"
                                    key="0-13-0"
                                    id="0-13-0" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、生活重点设备使用规范"
                                        key="0-13-0-0"
                                        id="0-13-0-0" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.1 消防泵操作规范"
                                            key="0-13-0-0-0"
                                            id="0-13-0-0-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.2 太阳能热水控制箱操作规范"
                                            key="0-13-0-0-1"
                                            id="0-13-0-0-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="1.3 自来水增压泵房运行管理规范"
                                            key="0-13-0-0-2"
                                            id="0-13-0-0-2" className="siderNum"
                                        />
                                    </TreeNode>
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、生产重点设备使用规范"
                                        key="0-13-0-1"
                                        id="0-13-0-1" className="siderNum"
                                    >
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.1 轮胎拆装机安全使用规范"
                                            key="0-13-0-1-0"
                                            id="0-13-0-1-0" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.2 动平衡机安全使用规范"
                                            key="0-13-0-1-1"
                                            id="0-13-0-1-1" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.3 角磨机安全使用规范"
                                            key="0-13-0-1-2"
                                            id="0-13-0-1-2" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.4 手电钻安全使用规范"
                                            key="0-13-0-1-3"
                                            id="0-13-0-1-3" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.5 电动单梁起重机安全操作规程"
                                            key="0-13-0-1-4"
                                            id="0-13-0-1-4" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.6 电焊、氧气乙炔安全操作规范"
                                            key="0-13-0-1-5"
                                            id="0-13-0-1-5" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.7 电焊机安全操作规程"
                                            key="0-13-0-1-6"
                                            id="0-13-0-1-6" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.8 千斤顶安全操作规程"
                                            key="0-13-0-1-7"
                                            id="0-13-0-1-7" className="siderNum"
                                        />
                                        <TreeNode
                                            icon={<Icon type="carry-out"/>}
                                            title="2.9 压床安全技术操作规范"
                                            key="0-13-0-1-8"
                                            id="0-13-0-1-8" className="siderNum"
                                        />
                                    </TreeNode>
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="二、精密设备仪器使用规范"
                                    key="0-13-1"
                                    id="0-13-1" className="siderNum"
                                >
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="1、摄影摄像器材使用规范"
                                        key="0-13-1-0"
                                        id="0-13-1-0" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="2、数字绝缘电阻测试仪使用规范"
                                        key="0-13-1-1"
                                        id="0-13-1-1" className="siderNum"
                                    />
                                    <TreeNode
                                        icon={<Icon type="carry-out"/>}
                                        title="3、轮轴定位设备操作规范"
                                        key="0-13-1-2"
                                        id="0-13-1-2" className="siderNum"
                                    />
                                </TreeNode>
                                <TreeNode
                                    icon={<Icon type="carry-out"/>}
                                    title="三、对应设备各项表格范本"
                                    key="0-13-2"
                                    id="0-13-2" className="siderNum"
                                />

                            </TreeNode>
                        </Tree>
                    </div>
                </div>
                </div>
                    );
                    }
                    }

                    export default Index;